// Scan previews are API endpoints that need the access token. react-pdf
// fetches them itself, so the token travels as an Authorization header
// (never in the URL, which would end up in logs and history).

export type PdfPreviewSource = {
  url: string
  httpHeaders: Record<string, string>
}

/** Only same-origin API paths ("/api/v1/..."): never an absolute or
 * protocol-relative URL taken from an event. */
export function isSameOriginApiPath(url: string | null | undefined): url is string {
  return typeof url === 'string' && url.startsWith('/api/v1/') && !url.startsWith('//') && !url.includes('\\')
}

export function pdfPreviewSource(
  url: string | null | undefined,
  token: string | null | undefined,
): PdfPreviewSource | null {
  if (!isSameOriginApiPath(url) || !token) return null
  return { url, httpHeaders: { Authorization: `Bearer ${token}` } }
}

/** The backend marks each event with `own` for its subscriber: the panel only
 * shows the user's own scans, not those of colleagues at the firm.
 * No flag (backend not restarted yet) keeps the previous behaviour. */
export function isOwnScanEvent(event: object): boolean {
  return (event as { own?: unknown }).own !== false
}
